<template>
  <v-row>
    <v-col cols="auto">
      <v-radio-group v-model="question.value" @change="saveAnswer">
        <v-radio
          v-for="(answer, i) in question.multipleChoiceAnswers"
          :key="i"
          :label="answer.answer"
          :value="answer.id"
        ></v-radio>
      </v-radio-group>
      <div v-if="showRequiredError" class="error--text">
        Answer is required
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyQuestionMultipleChoice",
  props: { showRequiredError: { type: Boolean, default: false } },
  data: () => ({}),
  computed: mapGetters({
    question: "survey/current_step",
    is_preview: "survey/is_preview"
  }),
  methods: {
    saveAnswer() {
      if (this.is_preview) {
        return;
      }
      this.$store
        .dispatch("survey/saveSurveyAnswer", {
          id: this.question.id,
          value: this.question.value
        })
        .catch(() => {
          //redirect to error page
        });
    }
  }
};
</script>
